import {
  Box,
  Center,
  Heading,
  SimpleGrid,
  GridItem,
  Grid,
  Flex,
  Stack,
  Text,
  useColorModeValue as mode,
  useDisclosure, 
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  FormControl,
  Input,
  ModalCloseButton,
  FormLabel,
  ModalFooter,
  Img,
  Button,
  theme,
  useMediaQuery,
  List, ListItem, ListIcon, OrderedList, UnorderedList,
  HStack
} from "@chakra-ui/react";
import { Logo } from "components/logo";
import { useState, useEffect, useRef } from "react";
import { DurationSwitcher, BillingFrequency } from "../duration-switcher";
import { PricingCard } from "../pricing/pricing-card";
import { PlansEnterprise } from "../pricing/plansEnterprise";
import { useSession } from "next-auth/react";
import { useRouter } from "next/dist/client/router";
import * as analytics from "../../utils/analytics";
import { updateEmail, guessTimezone, initUserAnalytics } from "../../controllers/settings";
import { warm } from "../../controllers/search";
import ShoutoutEmbed from 'shoutout-react'
import { MdCheckCircle } from 'react-icons/md';
import Payment from "components/payment";
import { SocialProof } from "../social-proof";
import { GiftGuide } from "../gift-guide";
import { firebaseClient, firebaseAuth } from "../../firebaseClient";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { useLocation } from "utils/useLocation";
import { prices, discounts } from "../pricing/pricing";
import { setInLocalStorage } from "../../utils/helpers";
import { ModalInfoIcon } from "components/popups/ModalInfoIcon";
import { variant } from "theme/names";

export const OnboardEnterprise = ({discount, query}) => {
  const router = useRouter();
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"


  const [email, setEmail] = useState("");
  const [billingFrequency, setBillingFrequency] = useState<BillingFrequency>("monthly");
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isLoading, setIsLoading] = useState(false);
  const initialRef = useRef<HTMLInputElement>(null);
  const isAuthenticated = useFirebaseUser();
  const { isFromIndia } = useLocation();
  const [isTooSmall] = useMediaQuery("(max-width: 800px)");

  useEffect(() => {
    // let isSkipped = (localStorage.getItem('isSkippedEmailPopup') == "true");
    // console.log("isSkipped: " + isSkipped);
    // if (!isSkipped)
    //   onOpen();
  }, []);

  useEffect(() => {

    if (!email && session?.user?.data?.email)
      //@ts-ignore
      setEmail(session?.user?.data?.email);

    if (isAuthenticated) 
      guessTimezone(session);

  }, [session, isAuthenticated]);

  useEffect(() => {
    if (isFromIndia) {
      setBillingFrequency("yearly")
    }
  }, [isFromIndia])

  const skipPopup = () => {
    onClose();
    setInLocalStorage('isSkippedEmailPopup', "true");
  }

  const banner = query.ref === "producthunt" && (
    <Box as="section" px={{ base: "6", md: "8" }} marginTop={{ base: "-4", lg: "-8" }}>
      <HStack
        justifyContent="center"
        border="4px"
        maxWidth="lg"
        margin="auto"
        borderRadius="xl"
        borderColor="#da5630"
        padding="2"
        textAlign="center"
      >
        <Text fontWeight="medium">
          <b>Product Hunters</b> 👉 grab a plan and get your first month for $1 🎉
        </Text>
      </HStack>
    </Box>
  )

  return (
    <>
      {/* {banner} */}
      <Box as="section" py="10">
        <Box
          maxW={{ base: "xl", md: "7xl" }}
          mx="auto"
          px={{ base: "6", md: "8" }}
        >
          <Center>
            <Heading
              mt="4"
              textAlign="center"
              fontWeight="900"
              fontSize="46px"
              maxW="500px"
            >
              <b>Leverage Twitter & AI to grow your business faster</b>
            </Heading>
          </Center>

          <SocialProof />
          {/* {
            !isTooSmall && (
              <SocialProof />
            )
          } */}

          {isFromIndia && (!discount || discount == discounts.india.yearly) && (
            <DurationSwitcher
              mt={{ base: "4", lg: "-6" }}
              mb="10"
              onChange={() =>
                setBillingFrequency(
                  billingFrequency === "monthly" ? "yearly" : "monthly"
                )
              }
              billingFrequency={billingFrequency}
              discountOf="40"
            />
          )}

          {(discount == "EARLYBIRD" || discount == "EARLYACCESS") && (
            <Center>
              <GiftGuide
                title="🎁 EARLY ACCESS SPECIAL 🎁"
                description="Get powerful AI features for the price of the starter plan"
                bg={mode("blue.400", "gray.700")}
                maxW={"600px"}
                rounded="full"
                p={4}
                style={{
                  title: { w: "250px", top: "-35px" },
                  description: { color: "white" },
                }}
              />
            </Center>
          )}

          <PlansEnterprise
            billingFrequency={billingFrequency}
            discount={discount}
            customCancelUrl="onboardnewchoice"
            isFromIndia={isFromIndia}
            isEnterpriseOnly={true}
          />

          {
            // session?.user?.data?.abTestFreeGuide && (
            // <Center>
            //   <GiftGuide title="Included 🎁" description="Our 25+ pages Twitter Growth Guide 📕 (valued $49)" bg={mode("gray.700", "gray.700")} />
            // </Center>
            // )
          }
        </Box>

        <Box p={4} display="flex" flexDirection="column" alignItems="center">
          <Heading textAlign="center" mt={8} mb={16}>
            See what people say about us
          </Heading>
          <Box minWidth="60%" maxWidth="1200px">
            <ShoutoutEmbed url="TweetHunter" />
          </Box>
        </Box>
        <Modal
          isOpen={isOpen}
          onClose={skipPopup}
          closeOnOverlayClick={false}
          //@ts-ignore
          initialFocusRef={initialRef}
          size="xl"
        >
          <ModalOverlay bg="white" />
          <ModalContent>
            <ModalHeader>
              {/* <ModalInfoIcon /> */}
              <Box display="flex" justifyContent="space-between">
                <Text>
                  {"Thanks for signing up " +
                    (session?.user?.data?.name
                      ? session?.user?.data?.name
                      : "")}
                </Text>
                {session?.user?.image && (
                  <Img
                    w="10"
                    h="10"
                    rounded="3xl"
                    objectFit="cover"
                    src={session?.user?.image}
                    alt="Chakra UI"
                    mr={2}
                  />
                )}
              </Box>
            </ModalHeader>
            <ModalBody pb={6}>
              <FormControl
                as="form"
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <FormLabel pb={3} pl={1} fontSize="md" fontWeight="400">
                  You’re a couple steps away from unlocking the power of Tweet
                  Hunter and <b>becoming a tweet machine.</b>
                </FormLabel>
                <FormLabel pb={3} pl={1} fontSize="md" fontWeight="400">
                  We use email to send you{" "}
                  <b>personalized tweet recommendations</b> and perform an{" "}
                  <b>AI-powered analysis of your Twitter account.</b>
                </FormLabel>
                <FormLabel pb={5} pl={1} fontSize="md" fontWeight="400">
                  <b>
                    Could you please confirm this email is the one you usually
                    check?
                  </b>{" "}
                  Or change it to your usual email.
                </FormLabel>
                <Input
                  type="email"
                  ref={initialRef}
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>
            </ModalBody>

            <ModalFooter mb={2}>
              <Button
                onClick={async () => {
                  setIsLoading(true);
                  updateEmail(session?.user?.uid, email);
                  skipPopup();
                  setIsLoading(false);
                }}
                // colorScheme="blue"
                variant={variant.Button.primary}
                isLoading={isLoading}
              >
                Save
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};
